import { render } from "./SheetCatalogueAdminView.vue?vue&type=template&id=4a87164a&scoped=true"
import script from "./SheetCatalogueAdminView.vue?vue&type=script&lang=js"
export * from "./SheetCatalogueAdminView.vue?vue&type=script&lang=js"

import "./SheetCatalogueAdminView.vue?vue&type=style&index=0&id=4a87164a&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a87164a"]])

export default __exports__